module.exports = __webpack_public_path__ + "d3e015724494cf1875244c3ff97376f2.svg";